export default __webpack_public_path__ + "static/loadLogo-87acf69dd7b8cd0b7c20fdebfc910264.png";